interface Props {
  count: number;
}

export function CustomerDuplicateWarning({ count }: Props) {
  if (count === 0) return null;
  return (
    <div className="flex items-center gap-2 px-3 py-2 bg-yellow-50 border border-yellow-200 rounded-lg text-yellow-800 text-sm">
      <span aria-hidden="true">⚠️</span>
      <span>類似顧客が見つかりました（{count}件）。登録は続行できます。</span>
    </div>
  );
}
